import styled from 'styled-components';

const ChamberFieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`;

const ChamberLegend = styled.legend`
  font-size: 0.9rem;
  color: #000000;
  margin-bottom: 1rem;
  padding: 0;
`;

const RadioRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;

  @media (min-width: 769px) {
    flex-direction: row;
    gap: 1rem;
  }
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #212121;

  input {
    accent-color: #0a819f;
    width: 1rem;
    height: 1rem;
  }
`;

export default function ChamberFilter({ chamberFilter, setChamberFilter, name = 'chamberFilterSidebar' }) {
  if (!setChamberFilter) return null;

  return (
    <ChamberFieldset>
      <ChamberLegend>Chamber</ChamberLegend>
      <RadioRow>
        <RadioOption>
          <input
            type="radio"
            name={name}
            value="both"
            checked={chamberFilter === 'both'}
            onChange={() => setChamberFilter('both')}
          />
          Any
        </RadioOption>
        <RadioOption>
          <input
            type="radio"
            name={name}
            value="assembly"
            checked={chamberFilter === 'assembly'}
            onChange={() => setChamberFilter('assembly')}
          />
          Assembly
        </RadioOption>
        <RadioOption>
          <input
            type="radio"
            name={name}
            value="senate"
            checked={chamberFilter === 'senate'}
            onChange={() => setChamberFilter('senate')}
          />
          Senate
        </RadioOption>
      </RadioRow>
    </ChamberFieldset>
  );
}
